import RoutinesIcon from "../common/icons/RoutinesIcon";

export default [
  {
    id: 10000,
    children: [
      {
        id: 10001,
        name: "Dashboard",
        iconTag: RoutinesIcon,
        page: "dashboard",
        page_args: {},
      },
    ],
  },
];
